{
  "recordingFilterBar": {
    "text": "Oldest data:",
    "text2": "Latest data:",
    "label": "Recording date",
    "previousDay": "Previous day",
    "nextDay": "Next day"
  },
  "recordingTable": {
    "label": "Recording time",
    "text": "{{value}}:00",
    "label2": "File size",
    "label3": "Playback",
    "text2": "Play"
  },
  "recording": {
    "title": "Recording history",
    "alert": "The recording history couldn't be loaded.",
    "alert2": "There are no recordings for this day."
  }
}
